import React from "react";

function LinkedInIcon(props) {
  return (
    <svg
      className={`linkedinIcon ${props.className || ""}`}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 256 256"
    >
      <path
        fill="#c9cacc"
        strokeMiterlimit="10"
        d="M8.421 14h.052C11.263 14 13 12 13 9.5 12.948 6.945 11.263 5 8.526 5S4 6.945 4 9.5C4 12 5.736 14 8.421 14zM4 17h9v26H4zm40 9.5a9.5 9.5 0 00-9.5-9.5 9.474 9.474 0 00-7.5 3.684V17h-9v26h9V28a4 4 0 018 0v15h9V26.5z"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        transform="scale(5.33333)"
      ></path>
    </svg>
  );
}

export default LinkedInIcon;